import React from 'react';
import ReactDOM from 'react-dom';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter } from 'react-router-dom'; 
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0E71C8',
    },
    secondary: {
      main: '#323F4B',
    },
    background: {
      default: '#F2F2F2',
    },
    text: {
      primary: '#323F4B',
    },
  },
});

console.log('App loading started...');

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

console.log('App loaded successfully');


serviceWorker.unregister();
